<div class="m-form-row" [class]="'col--'+columns">
  <ng-content></ng-content>
</div>
